const getUrlParams = (url) => {
  const hashes = url.slice(url.indexOf('?') + 1).split('&');
  const params = {};
  hashes.map(hash => {
    const [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val)
  });
  return params;
};

const params = getUrlParams(window.location.search);

export const getUrlParam = (name) => {
  return params[name];
}

export const urlParamsToObject = (URLSearchParams) => {
  const result = {};

  for (let [key, value] of URLSearchParams.entries()) {
    if (result.hasOwnProperty(key)) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }

    } else {
      result[key] = value;
    }
  }

  return result;
}
